import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Start Main 
import Header from './components/main/Header';

// Start Pages
import Home from './components/pages/Home';


const App = () => {
    return (
        <>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
            </Routes>


        </>
    );
};

export default App;
